// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth__Auth___2N4mh","black-pink":"Auth__black-pink___3ogHy","AuthForm":"Auth__AuthForm___w8QpK"};